export const LOCAL_STORAGE = {
  SIGNUP_INFORMATION_LOCAL: 'SIGNUP_INFORMATION_LOCAL',
  ACCESS_TOKEN: 'access_token',
  DEFAULT_COUNTRY: 'DEFAULT_COUNTRY',
  DEFAULT_LANGUAGE: 'DEFAULT_LANGUAGE',
  I18NEXTLNG: 'i18nextLng',
  ACCOUNT_INFO: 'ACCOUNT_INFO',
  JUST_CREATED_ACCOUNT: 'just_created_account',
  AREA_ID: 'AREA_ID',
}
